import React from 'react';
import { useHelmet, ScriptTag } from '@thd-nucleus/thd-helmet';

const siteSearchHandler = () => {

  const content = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    url: 'https://www.homedepot.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.homedepot.com/s/{search_term_string}?NCNI-5&gsitesearch',
      'query-input': 'required name=search_term_string'
    },
  };

  return new ScriptTag({ content, id: 'site-search' });
};

const SiteSearchMetadata = () => {

  useHelmet('siteSearchMetatag', {}, siteSearchHandler, []);

  return null;
};

SiteSearchMetadata.propTypes = {
};

export { SiteSearchMetadata };